<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import useMarkdown from '~/composables/useMarkdown'
import { useStore } from '~/store'
import { dialog } from '~/routing'

import Heading from '~/ui/Heading.vue'
import Modal from '~/ui/Modal.vue'
import SanitizedHtml from '~/ui/SanitizedHtml.vue'

const { t } = useI18n()
const store = useStore()

const nodeinfo = computed(() => store.state.instance.nodeinfo)
const terms = useMarkdown(() => nodeinfo.value?.metadata?.terms ?? '')
</script>

<template>
  <Modal
    v-if="terms"
    v-bind="dialog.model('terms')"
  >
    <Heading
      :h1="t('components.AboutPod.header.terms')"
      page-heading
    />
    <SanitizedHtml :html="terms" />
  </Modal>
</template>
